import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useLocation } from "react-router-dom";
import SchoolInnerPageBanner from "../../components/SchoolInnerPageBanner";
import '../../components/AboutSection.css';
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const AboutPage = () => {
  const location = useLocation();

  const { school_slug } = useParams();
  const [mv, setMv] = useState(null);

  const [affiliation, setAffiliation] = useState(null);
  const [awards, setAwards] = useState(null);
  const [csr, setCsr] = useState(null);
  const [mentorship, setMentorship] = useState(null);

  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // For scroll top

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const sectionId = location.state?.scrollTo;
    if (!sectionId) return;

    const timer = setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 150);

    return () => clearTimeout(timer);
  }, [location.key]);

  useEffect(() => {
    scrollToTop();
  }, []);

  /* ---------------- FETCH ABOUT DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    setLoading(true);

    axios
      .get(`${baseAPIUrl}api/about/${finalSchoolSlug}`)
      .then((res) => {
        const data = res.data?.data;
        setAbout(
          data && Object.values(data).some(v => v !== null && v !== "")
            ? data
            : null
        );
        setLoading(false);
      })
      .catch(() => {
        setAbout(null);
        setLoading(false);
      });
  }, [school_slug]);

  /* ---------------- FETCH MISSION VISION DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(`${baseAPIUrl}api/about/mission_vision/${finalSchoolSlug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.heading ||
            res.data.data.mission_content ||
            res.data.data.vission_content
          )
        ) {
          setMv(res.data.data);
        } else {
          setMv(null); // ❌ hide section
        }
      })
      .catch(() => setMv(null));
  }, [school_slug]);

  /* ---------------- FETCH AFFILIATIONS DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(`${baseAPIUrl}api/about/affiliations/${finalSchoolSlug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.section?.heading ||
            res.data.data.section?.paragraph_1 ||
            res.data.data.rows?.length > 0
          )
        ) {
          setAffiliation(res.data.data);
        } else {
          setAffiliation(null); // ❌ hide section
        }
      })
      .catch(() => setAffiliation(null));
  }, [school_slug]);

  /* ---------------- FETCH ACCOLADES & AWARDS DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";
    axios
      .get(`${baseAPIUrl}api/about/awards/${finalSchoolSlug}`)
      .then((res) => {
        if (
          res.data.status === 1 &&
          res.data.data &&
          (
            res.data.data.section?.heading ||
            res.data.data.section?.intro_text ||
            res.data.data.items?.length > 0
          )
        ) {
          setAwards(res.data.data);
        } else {
          setAwards(null); // ❌ hide section
        }
      })
      .catch(() => setAwards(null));
  }, [school_slug]);

  /* ---------------- FETCH CSR DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(`${baseAPIUrl}api/about/csr/${finalSchoolSlug}`)
      .then((res) => {
        if (res.data.status === 1) {
          setCsr(res.data.data);
        } else {
          setCsr(null);
        }
      })
      .catch((err) => {
        console.error("CSR API ERROR:", err);
        setCsr(null);
      });
  }, [school_slug]);

  /* ---------------- FETCH MENTORSHIP DATA ---------------- */
  useEffect(() => {
    const finalSchoolSlug = school_slug || "tigps-main";

    axios
      .get(`${baseAPIUrl}api/about/mentorship/${finalSchoolSlug}`)
      .then((res) => {
        if (res.data.status === 1) {
          setMentorship(res.data.data);
        } else {
          setMentorship(null);
        }
      })
      .catch((err) => {
        console.error("MENTORSHIP API ERROR:", err);
        setMentorship(null);
      });
  }, [school_slug]);




  // For About

  const hasAboutContent =
    about &&
    Object.values(about).some(
      (value) => value !== null && value !== ""
    );

  // For Mission & Vision

  const hasMv =
    !!mv &&
    (mv.heading || mv.mission_content || mv.vission_content || mv.mv_image);
  const hasAffiliation =
    !!affiliation &&
    affiliation.section &&
    (
      affiliation.section.heading ||
      affiliation.section.paragraph_1 ||
      affiliation.rows?.length > 0
    );

  // For Accolades & awards

  const hasAwards =
    !!awards &&
    awards.section &&
    (
      awards.section.heading ||
      awards.items?.length > 0 ||
      awards.section.highlight_text
    );

  // For CSR

  const hasCsr =
    !!csr &&
    csr.section &&
    (
      csr.section.heading ||
      csr.blocks?.length > 0 ||
      csr.images?.length > 0
    );

  // For Mentorship
  const hasMentorship =
    !!mentorship &&
    mentorship.section &&
    mentorship.section.heading;



  return (
    <div>
      {/* Hero Image Section */}
      <SchoolInnerPageBanner />

      {/* About Content Section */}
      {hasAboutContent && (
        <section id="about-us"
          style={{
            padding: "80px 20px",
            background: "rgb(100, 19, 32)",
            color: "white",
          }}
        >
          <div className="container" style={{ maxWidth: "1200px", margin: "0 auto" }}>
            <div className="row align-items-center">

              {/* TEXT */}
              <div className="col-lg-8">
                {about?.heading && (
                  <h1
                    style={{
                      fontSize: "2.5rem",
                      marginBottom: "30px",
                      fontFamily: "Lora",
                    }}
                  >
                    {about?.heading}
                  </h1>
                )}

                {about?.paragraph_1 && <p>{about.paragraph_1}</p>}
                {about?.paragraph_2 && <p>{about.paragraph_2}</p>}
                {about?.paragraph_3 && <p>{about.paragraph_3}</p>}
              </div>

              {/* IMAGE */}
              {about?.about_section_image && (
                <div className="col-lg-4">
                  <img
                    src={`${about.about_section_image}`}
                    alt={about.heading || "About"}
                    style={{ width: "100%", borderRadius: "10px" }}
                    onError={(e) => (e.currentTarget.style.display = "none")}
                  />
                </div>
              )}

            </div>
          </div>
        </section>
      )}

      {/* Affiliations and Certifications Section */}
      {hasAffiliation &&
        (
          affiliation.section.paragraph_1 ||
          affiliation.section.paragraph_2 ||
          affiliation.section.paragraph_3 ||
          affiliation.rows?.length > 0
        ) && (
          <section id="affiliations-and-certifications" style={{ padding: '80px 20px', background: 'white' }}>
            <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

              <h2 style={{ fontSize: '2.5rem', color: "rgb(100, 19, 32)", fontWeight: '600', textAlign: 'center', marginBottom: '30px', fontFamily: 'Lora' }}>
                {affiliation.section.heading}
              </h2>

              {affiliation.section.paragraph_1 && (
                <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', fontFamily: 'Lora' }}>
                  {affiliation.section.paragraph_1}
                </p>
              )}

              {affiliation.section.paragraph_2 && (
                <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '20px', fontFamily: 'Lora' }}>
                  {affiliation.section.paragraph_2}
                </p>
              )}

              {affiliation.section.paragraph_3 && (
                <p style={{ fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '40px', fontFamily: 'Lora' }}>
                  {affiliation.section.paragraph_3}
                </p>
              )}

              {/* TABLE */}
              {affiliation.rows && affiliation.rows.length > 0 && (
                <div style={{ overflowX: 'auto', marginBottom: '30px' }}>
                  <table style={{
                    width: '100%', minWidth: '600px', maxWidth: '800px', margin: '0 auto', backgroundColor: 'rgb(100, 19, 32)', color: '#fff', borderRadius: '10px', overflow: 'hidden', fontFamily: 'Lora', border: '2px solid #fff', borderCollapse: 'collapse'

                  }}>
                    <thead>
                      <tr style={{ backgroundColor: 'rgb(100, 19, 32)' }}>
                        <th style={{ padding: '12px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '1.1rem', color: '#fff', whiteSpace: 'nowrap' }}>SL</th>
                        <th style={{ padding: '12px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '1.1rem', color: '#fff', whiteSpace: 'nowrap' }}>SCHOOL</th>
                        <th style={{ padding: '12px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '1.1rem', color: '#fff', whiteSpace: 'nowrap' }}> CLASS</th>
                        <th style={{ padding: '12px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '1.1rem', color: '#fff', whiteSpace: 'nowrap' }}>AFFILIATION NO</th>
                      </tr>
                    </thead>

                    <tbody>
                      {affiliation.rows.map((row, index) => (
                        <tr key={index}>
                          <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '0.9rem', fontFamily: 'Metropolis-Regular' }}>{index + 1}</td>
                          <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '0.9rem', fontFamily: 'Metropolis-Regular' }}>{row.school_name}</td>
                          <td style={{ padding: '10px 8px', textAlign: 'center', border: '1px solid #fff', fontSize: '0.9rem', fontFamily: 'Metropolis-Regular' }}>{row.class_range}</td>
                          <td style={{ padding: '10px 8px', textAlign: 'center', fontWeight: '600', color: '#fff', border: '1px solid #fff', fontSize: '0.9rem', fontFamily: 'Metropolis-Regular' }}>{row.affiliation_no}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {affiliation.section.paragraph_after_table && (
                <p style={{ fontSize: "1.1rem", lineHeight: "1.8" }}>
                  {affiliation.section.paragraph_after_table}
                </p>
              )}

            </div>
          </section>
        )}

      {/* Awards and Achievements Section */}
      {hasAwards &&
        (
          awards.section.intro_text ||
          awards.items?.length > 0 ||
          awards.section.highlight_text
        ) && (
          <section id="accolades-and-awards" style={{ padding: "80px 20px", background: "#f8f9fa" }}>
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>

              {/* Heading */}
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "600",
                  color: "rgb(100, 19, 32)",
                  textAlign: "center",
                  marginBottom: "50px",
                  fontFamily: "Lora"
                }}
              >
                {awards.section.heading}
              </h2>

              {/* Intro text */}
              {awards.section.intro_text && (
                <p
                  style={{
                    lineHeight: "1.8",
                    color: "#333",
                    marginBottom: "25px",
                  }}
                >
                  {awards.section.intro_text}
                </p>
              )}

              {/* Award items */}
              {awards.items && awards.items.length > 0 && awards.items.map((item, idx) => (
                <div key={idx} style={{ marginBottom: "25px" }}>
                  {item.title && (
                    <h4
                      style={{
                        fontSize: "1.4rem",
                        color: "rgb(100, 19, 32)",
                        marginBottom: "10px",
                        fontFamily: "Lora"
                      }}
                    >
                      {item.title}
                    </h4>
                  )}

                  {item.description && (
                    <p
                      style={{
                        lineHeight: "1.6",
                        color: "#333",
                        whiteSpace: "pre-line"
                      }}
                    >
                      {item.description}
                    </p>
                  )}
                </div>
              ))}

              {/* Highlight text */}
              {awards.section.highlight_text && (
                <p className="accolades-awards-p">
                  {awards.section.highlight_text}
                </p>
              )}

              {/* Image – render ONLY if exists */}
              {awards.section.accolades_section_image && (
                <div style={{ textAlign: "center" }}>
                  <img
                    src={awards.section.accolades_section_image}
                    alt={awards.section.heading}
                    style={{
                      maxWidth: "600px",
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)"
                    }}
                    onError={(e) => {
                      e.target.style.display = "none";
                    }}
                  />
                </div>
              )}

            </div>
          </section>
        )}

      {/* Our Programs towards the Society Section */}
      {hasCsr && (
        <section id="our-programs-towards-the-society" style={{ padding: "80px 20px", background: "rgb(100, 19, 32)", color: "white" }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

            <h2 style={{ fontSize: '2.5rem', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>{csr.section.heading}</h2>
            <h3 style={{ fontSize: '1.4rem', marginBottom: '20px', fontFamily: 'Lora' }}>{csr.section.intro_heading}</h3>
            <p style={{ lineHeight: '1.8', marginBottom: '25px' }}>{csr.section.intro_paragraph}</p>

            {csr.blocks.map((item, idx) => (
              <div key={idx}>
                <h4 style={{ fontSize: '1.4rem', marginBottom: '15px', fontFamily: 'Lora' }}>{item.block_heading}</h4>
                <p style={{ lineHeight: '1.7', marginBottom: '25px' }}>{item.block_content}</p>
              </div>
            ))}

            <p style={{ lineHeight: '1.7', marginBottom: '40px', }}>{csr.section.last_paragraph}</p>


            <div className="row">
              {csr.images.map((img, i) => (
                <div key={i} className="col-md-4 mb-3">
                  <img src={img.image_name} style={{ width: '100%', borderRadius: '10px', boxShadow: '0 8px 20px rgba(0, 0, 0, 0.3)' }} />
                </div>
              ))}
            </div>

          </div>
        </section>
      )}

      {/* Mentorship Section */}
      {hasMentorship && (
        <section id="mentorship" style={{ padding: '80px 20px', background: 'white' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

            <h2 style={{ fontSize: '2.5rem', color: 'rgb(100, 19, 32)', textAlign: 'center', marginBottom: '50px', fontFamily: 'Lora' }}>{mentorship.section.heading}</h2>

            <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: '#333', marginBottom: '25px', fontFamily: 'Lora', fontStyle: 'italic', textAlign: 'center' }}>
              {mentorship.section.quote_1}
            </p>

            <p style={{ lineHeight: '1.7', color: '#333', marginBottom: '25px' }}>{mentorship.section.paragraph_1}</p>
            <p style={{ lineHeight: '1.7', color: '#333', marginBottom: '25px' }}>{mentorship.section.paragraph_2}</p>

            <p className="accolades-awards-p" >
              {mentorship.section.highlight_text_1}
            </p>

            <div className="row" style={{ marginBottom: '40px' }}>

              {mentorship.images.map((c, i) => (
                <div key={i} className="col-md-3 col-6 mb-4">
                  <img
                    src={c.image_name}
                    style={{ width: '100%', height: '200px', objectFit: 'cover', borderRadius: '10px', boxShadow: '0 4px 10px rgba(0,0,0,0.2)' }}
                  />
                  <h4 style={{ textAlign: 'center', marginTop: '10px', fontFamily: 'Lora', fontSize: '1.1rem', color: 'rgb(100, 19, 32)' }}>
                    {c.caption}
                  </h4>
                </div>
              ))}
            </div>
            <p style={{ color: 'rgb(100, 19, 32)', marginBottom: '25px', textAlign: 'center', fontWeight: '600' }}>
              {mentorship.section.highlight_text_2}
            </p>

            <p style={{ fontStyle: 'italic', textAlign: 'center' }}>
              {mentorship.section.quote_2}
            </p>

          </div>
        </section>
      )}
    </div>
  );



};
export default AboutPage;